module.exports = __webpack_public_path__ + "static/media/fly0269.873be51e.webp";